import { produce } from 'immer';
import { SetState, create } from 'zustand';
import { persist } from 'zustand/middleware';
import { MissionGameAction, MissionGameState, MissionGameStore } from '~/types';

const initialMissionGameState = (): MissionGameState => ({
  answerContext: [],
});

const missionGameActions = (
  set: SetState<MissionGameStore>,
): MissionGameAction => ({
  setAnswerContext: (answers) => {
    set(
      produce((state: MissionGameStore) => {
        state.answerContext = answers;
      }),
    );
  },
});

const useMissionGameStore = create<MissionGameStore>()(
  persist(
    (set) => ({
      ...initialMissionGameState(),
      ...missionGameActions(set),
    }),
    {
      name: 'mission',
    },
  ),
);

export default useMissionGameStore;
